import type Stripe from 'stripe';
import { z } from 'zod';

export type StripePromoCoupon = Stripe.Coupon & { promoCode: string };

export type StripeStoreProduct = {
  product: Stripe.Product;
  price: Stripe.Price;
  coupon?: StripePromoCoupon;
};

export type StripePaywall = {
  oneTimePackages: StripeStoreProduct[];
  subscriptions: StripeStoreProduct[];
};

export const stripeProductBySkuRequestSchema = z.object({
  countryCode: z.string().min(2).max(2),
  platform: z.string().optional(),
  introOfferSku: z.string().optional(),
  os: z.string().optional(),
  promoCode: z.string().optional(),
});

export const stripePaywallByUserRequestSchema = z.object({
  countryCode: z.string().min(2).max(2),
  platform: z.string().optional(),
  introOfferSku: z.string().optional(),
  os: z.string().optional(),
  promoCode: z.string().optional(),
  app: z.enum(['galatea', 'candyjar']),
  defaultRevcatOfferingId: z.string(),
  callSource: z.string(),
});

export const stripePaywallRequestSchema = stripeProductBySkuRequestSchema.extend({
  offering: z.string(),
});

export type StripePaywallRequest = z.infer<typeof stripePaywallRequestSchema>;

// SKU not injected into the request schema since that's validated through a path param to satisfy REST semantics
export type StripeProductBySkuRequest = z.infer<typeof stripeProductBySkuRequestSchema> & { sku: string };

export type StripePaywallByUserRequest = z.infer<typeof stripePaywallByUserRequestSchema>;
